// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import Es6Promise from 'es6-promise';
require('es6-promise').polyfill();
Es6Promise.polyfill();
import Vue from 'vue'
import App from './App'
import router from './router'
import SlideVerify from 'vue-monoplasty-slide-verify';
// import VueNavTree from 'vue-nav-tree'
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import VueUeditorWrap from 'vue-ueditor-wrap'
import {getRequest,getFileRequest, postRequest, putRequest, deleteRequest} from './utils/http'
import utils from './utils/utils'
import { getOrderEnums } from './utils/orderEnums'
import alert from '../my_modules/alert'
import Directives from './directives'
import G from './../global';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import * as echarts from 'echarts';

Vue.use(Directives)
Vue.use(ElementUI);
Vue.use(alert) ;// 注意，Vue.use方法必须在new Vue之前被调用
Vue.use(preview)
// Vue.use(VueNavTree)
Vue.use(SlideVerify);
Vue.config.productionTip = false
Vue.component('vue-ueditor-wrap', VueUeditorWrap)
Vue.prototype.$get = getRequest;
Vue.prototype.$getFile = getFileRequest;
Vue.prototype.$post = postRequest;
Vue.prototype.$put = putRequest;
Vue.prototype.$delete = deleteRequest;
Vue.prototype.utils = utils;
Vue.prototype.G = G;
Vue.prototype.$echarts = echarts;
Vue.prototype.$getOrderEnums = getOrderEnums;
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js